import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-contacts';

const updateCustomerContactById = async (body, id) => {
  const method = 'PUT';
  const url = `${USE_CASE_URL}/${id}`;

  const json = await request({ method, url, body });
  return json;
};

export default updateCustomerContactById;
